(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-selector"] && !Shopify.designMode) return;
  try {
    
  /*
   * Pack picker: copy the chosen pack into the hidden quantity field and show
   * its total on the buy button. Delegated on document, so it also works after
   * the theme editor re-renders the section.
   */
  document.addEventListener('change', (event) => {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || !radio.matches('.fg-scent__pack-radio')) return;
    const form = radio.form;
    if (!form) return;
    const qty = form.querySelector('.fg-scent__qty');
    if (qty) qty.value = radio.value;
    const price = form.querySelector('[data-fg-pack-price]');
    if (price && radio.dataset.price) price.textContent = radio.dataset.price;
  });

  /* Back/forward cache can restore a checked radio with a stale hidden field. */
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.fg-scent__pack-radio:checked').forEach((radio) => {
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
